var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.show && _vm.hasScrollbar && _vm.showIcon == false
      ? _c("div", { staticClass: "table-scroll-slider" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.scrollPosition,
                expression: "scrollPosition",
                modifiers: { number: true },
              },
            ],
            staticClass: "custom-range",
            attrs: { type: "range", min: 0, max: _vm.maxScroll },
            domProps: { value: _vm.scrollPosition },
            on: {
              input: _vm.onSliderInput,
              __r: function ($event) {
                _vm.scrollPosition = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-bottom-right",
            staticStyle: {
              width: "10px",
              height: "10px",
              "margin-left": "10px",
            },
            on: { click: _vm.close },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showIcon
      ? _c("div", { staticClass: "icon", on: { click: _vm.selectIcon } }, [
          _c("i", { staticClass: "el-icon-top-left" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }